import React from 'react'
import styles from '../../styles/components/assets/AssetsInformationSystems.module.scss'

interface Props {
  label: string
  value: string
  variant?: 'primary' | 'secondary'
  onClick?: () => void
  title?: string
}

export default function OperationalKpiCard({
  label,
  value,
  variant = 'secondary',
  onClick,
  title,
}: Props) {
  const cardClass =
    variant === 'primary'
      ? `${styles.kpiCard} ${styles.kpiCardPrimary}`
      : `${styles.kpiCard} ${styles.kpiCardSecondary}`

  const inner = (
    <>
      <p className={styles.kpiLabel}>{label}</p>
      <p className={styles.kpiValue}>{value}</p>
    </>
  )

  if (onClick) {
    return (
      <button type="button" className={`${cardClass} ${styles.kpiCardButton}`} onClick={onClick} title={title}>
        {inner}
      </button>
    )
  }

  return (
    <article className={cardClass} title={title}>
      {inner}
    </article>
  )
}
